import { useLayoutEffect, useState } from "react";

/**
 * @function useWindowSize
 * @description Custom hook for managing window size state
 * @returns {[number | null, number | null]} - The width and height of the window
 */
const useWindowSize = (): [number | null, number | null] => {
  const [windowSize, setWindowSize] = useState<[number | null, number | null]>([
    null,
    null,
  ]);

  useLayoutEffect(() => {
    const windowSizeHandler = () => {
      setWindowSize([window.innerWidth, window.innerHeight]);
    };
    window.addEventListener("resize", windowSizeHandler);

    windowSizeHandler();

    return () => {
      window.removeEventListener("resize", windowSizeHandler);
    };
  }, []);

  return windowSize;
};

export default useWindowSize;
